// setChatroomUserDiscover.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set chat users discover filter
 * @kind action
 * @param {string} {category} - action param.
 * @return {Promise} Action promise.
 */
const setChatroomUserDiscover = data => async dispatch => {
  const selectPath = ['chatroom', 'discover'];
  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: { selectPath, data },
  });
};

export default setChatroomUserDiscover;
